import { inject, Injectable } from '@angular/core';
import { MarketGroup } from '@clean-code/models';
import { ID } from '@clean-code/models/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';
import { MarketWidgetDataService } from './widget.data.service';

@Injectable({ providedIn: 'root' })
export class MarketGroupDataService {
  private graphqlService = inject(GraphqlService);

  public static readonly marketGroupParams = `
        id
        name
        type
        items
        {
            ${MarketWidgetDataService.marketWidgetParams}
        }
        settings
        {
            id
            position
            showTitle
        }
        summaryColumnId
        detailColumnId
    `;

  private readonly entityName = 'marketGroup';

  getAll$(id: ID): Observable<MarketGroup[]> {
    const query = `
            query($id: Int!) {
                ${this.entityName}GetAll(id: $id) {
                    ${MarketGroupDataService.marketGroupParams}
                }
            }
        `;

    return this.graphqlService.query<MarketGroup[]>(query, { id });
  }

  getById$(id: ID): Observable<MarketGroup> {
    const query = `
            query($id: Int!) {
                ${this.entityName}GetById(id: $id) {
                    ${MarketGroupDataService.marketGroupParams}
                }
            }
        `;

    return this.graphqlService.query<MarketGroup>(query, { id });
  }

  add$(input: MarketGroup): Observable<MarketGroup> {
    const mutation = `
            mutation ($input: MarketGroupInput!) {
                ${this.entityName}Add(input: $input)
                {
                    ${MarketGroupDataService.marketGroupParams}
                }
            }
        `;

    const variables = {
      input,
    };

    return this.graphqlService.mutation<MarketGroup>(mutation, variables);
  }

  update$(input: MarketGroup): Observable<MarketGroup> {
    const mutation = `
            mutation ($input: MarketGroupInput!) {
                ${this.entityName}Update(input: $input)
                {
                    ${MarketGroupDataService.marketGroupParams}
                }
            }
        `;

    const variables = {
      input,
    };

    return this.graphqlService.mutation<MarketGroup>(mutation, variables);
  }

  delete$(id: ID): Observable<boolean> {
    const mutation = `
            mutation {
                ${this.entityName}Delete(id: ${id})
            }
        `;

    return this.graphqlService.mutation<boolean>(mutation);
  }
}
